/**
 * DOG1 LP-Darm Bundle-Buy-Box
 *
 * Fork von dog1-lp-dental-buybox.js, reduziert auf das Bundle:
 *   - EINE Radio-Group (Bundle-Variante: Daily Essentials Pulver/Snack),
 *     kein Abo-Modus, quantity hardcoded auf 1.
 *   - Preis-Display (Preis, Streichpreis, absolute Ersparnis in €)
 *     aktualisiert sich beim Varianten-Wechsel aus data-price /
 *     data-compare. Bewusst kein Prozent-Rabatt im UI.
 *   - ATC-Klick (identisches LP-2-Pattern wie Dental):
 *     1) /cart/update.js mit qty 0 für ALLE Bundle-Varianten + Löffel
 *        (entfernt frühere LP-Items, andere Produkte bleiben)
 *     2) /cart/add.js mit Multi-Item-JSON-Body — Bundle-Variante (qty 1)
 *        + Löffel (qty 1). Atomar: beide rein oder beide raus.
 *     3) bei 2xx: window.location.href = '/checkout'
 *        bei Fehler: aria-live-Hinweis, Button wieder enabled
 *   - ATC ist <button type="button"> (kein <form>, kein name="add")
 *     → unsichtbar für Opus' Click-Capture. KEINE cart:*-Events.
 *
 * Löffel-Variant-ID kommt aus data-spoon-variant-id am Section-Root
 * (Section-Setting, Default 47531635736901). /cart-Endpoints akzeptieren
 * ausschließlich VARIANT-IDs — Product-IDs führen zu HTTP 422.
 */
(function () {
  'use strict';

  var ROOT = document.querySelector('.lp-darm-buybox');
  if (!ROOT) return;

  var SPOON_VARIANT_ID = (ROOT.dataset.spoonVariantId || '').trim();
  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: CURRENCY,
    }).format(cents / 100);
  }

  // ---------- DOM ----------
  var choiceRadios = ROOT.querySelectorAll('input[name="lp-darm-buybox-choice"]');
  var atcBtn = ROOT.querySelector('[data-lp-darm-atc]');
  var atcLabel = ROOT.querySelector('[data-lp-darm-atc-label]');
  var atcError = ROOT.querySelector('[data-lp-darm-error]');
  var totalSlot = ROOT.querySelector('[data-lp-darm-total]');
  var compareSlot = ROOT.querySelector('[data-lp-darm-compare]');
  var saveRow = ROOT.querySelector('[data-lp-darm-save]');
  var saveAmountSlot = ROOT.querySelector('[data-lp-darm-save-amount]');
  var saveBadge = ROOT.querySelector('[data-lp-darm-save-badge]');
  var stackCompareSlot = ROOT.querySelector('[data-lp-darm-stack-compare]');

  var ATC_LABEL_DEFAULT = atcLabel ? atcLabel.textContent.trim() : 'Jetzt Bundle sichern';
  var ATC_LABEL_LOADING = 'Wird hinzugefügt …';

  // Alle Bundle-Varianten-IDs für die Replace-Logik. Quelle: data-variant-id
  // auf den Choice-Cards — KEIN Hardcode, folgt der Produkt-Bindung.
  var BUNDLE_VARIANT_IDS = Array.prototype.slice
    .call(ROOT.querySelectorAll('[data-variant-id]'))
    .map(function (el) { return el.dataset.variantId; })
    .filter(function (id) { return id; });

  var REPLACEABLE_VARIANT_IDS = SPOON_VARIANT_ID
    ? BUNDLE_VARIANT_IDS.concat([SPOON_VARIANT_ID])
    : BUNDLE_VARIANT_IDS.slice();

  // ---------- Helpers ----------
  function getSelectedVariantCard() {
    var checked = ROOT.querySelector('input[name="lp-darm-buybox-choice"]:checked');
    if (checked) return checked.closest('[data-variant-id]');
    // Single-Variant-Produkt: keine Radio-Group gerendert → erste Card
    // existiert nicht; Preis-Daten stecken dann nur im Initial-Render.
    return ROOT.querySelector('[data-variant-id]');
  }

  // ---------- Preise ----------
  function renderPrices() {
    var card = getSelectedVariantCard();
    if (!card) return;
    var price = parseInt(card.dataset.price, 10);
    var compare = parseInt(card.dataset.compare, 10) || 0;
    if (!price) return;

    if (totalSlot) totalSlot.textContent = formatMoney(price);
    if (compareSlot) {
      if (compare > price) {
        compareSlot.textContent = formatMoney(compare);
        compareSlot.hidden = false;
      } else {
        compareSlot.hidden = true;
      }
    }
    if (stackCompareSlot && compare > price) {
      stackCompareSlot.textContent = formatMoney(compare);
    }

    var save = compare > price ? compare - price : 0;

    if (saveRow) {
      if (save > 0) {
        if (saveAmountSlot) saveAmountSlot.textContent = formatMoney(save);
        saveRow.hidden = false;
      } else {
        saveRow.hidden = true;
      }
    }
    if (saveBadge) {
      if (save > 0) {
        saveBadge.textContent = '−' + formatMoney(save);
        saveBadge.hidden = false;
      } else {
        saveBadge.hidden = true;
      }
    }
  }

  // ---------- ATC ----------
  function showError(msg) {
    if (!atcError) {
      window.alert(msg);
      return;
    }
    atcError.textContent = msg;
    atcError.hidden = false;
  }

  function clearError() {
    if (!atcError) return;
    atcError.hidden = true;
    atcError.textContent = '';
  }

  function setBusy(busy) {
    if (!atcBtn) return;
    if (busy) {
      atcBtn.setAttribute('aria-busy', 'true');
      atcBtn.setAttribute('disabled', 'true');
      if (atcLabel) atcLabel.textContent = ATC_LABEL_LOADING;
    } else {
      atcBtn.removeAttribute('aria-busy');
      atcBtn.removeAttribute('disabled');
      if (atcLabel) atcLabel.textContent = ATC_LABEL_DEFAULT;
    }
  }

  /**
   * Schritt 1: alle Bundle-Lines und Löffel-Lines aus dem Cart entfernen.
   * Andere Produkte bleiben unberührt. Single-XHR, atomar.
   */
  function removeExistingItems(callback) {
    if (!REPLACEABLE_VARIANT_IDS.length) {
      callback(true);
      return;
    }
    var formData = new FormData();
    REPLACEABLE_VARIANT_IDS.forEach(function (id) {
      formData.append('updates[' + id + ']', '0');
    });

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/update.js', true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        callback(true);
        return;
      }
      callback(false, 'Cart-Update fehlgeschlagen (HTTP ' + xhr.status + ').');
    };
    xhr.onerror = function () {
      callback(false, 'Netzwerk-Fehler beim Cart-Update.');
    };
    xhr.send(formData);
  }

  /**
   * Schritt 2: Bundle-Variante + Löffel in EINEM /cart/add.js POST.
   * Multi-Item-Format ist atomic. XHR statt fetch (Opus-Drawer-Bypass).
   */
  function addCurrentSelection(variantId, callback) {
    var items = [{
      id: parseInt(variantId, 10),
      quantity: 1
    }];
    if (SPOON_VARIANT_ID) {
      items.push({
        id: parseInt(SPOON_VARIANT_ID, 10),
        quantity: 1
      });
    }

    var body = JSON.stringify({ items: items });

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        callback(true);
        return;
      }
      var msg = 'Add-to-Cart fehlgeschlagen (HTTP ' + xhr.status + ').';
      try {
        var parsed = JSON.parse(xhr.responseText);
        msg = parsed.description || parsed.message || msg;
      } catch (_) { /* responseText war kein JSON */ }
      callback(false, msg);
    };
    xhr.onerror = function () {
      callback(false, 'Es gab einen Netzwerk-Fehler. Bitte versuche es erneut.');
    };
    xhr.send(body);
  }

  function handleAtcClick(e) {
    e.preventDefault();
    if (!atcBtn || atcBtn.hasAttribute('disabled')) return;

    var card = getSelectedVariantCard();
    if (!card) {
      showError('Bitte wähle eine Variante.');
      return;
    }

    var variantId = card.dataset.variantId;

    clearError();
    setBusy(true);

    removeExistingItems(function (removeOk, removeErr) {
      if (!removeOk) {
        setBusy(false);
        showError(removeErr);
        return;
      }
      addCurrentSelection(variantId, function (addOk, addErr) {
        if (!addOk) {
          setBusy(false);
          showError(addErr);
          return;
        }
        // Maximale Synchronität: direkt navigieren, kein Event-Dispatch.
        window.location.href = '/checkout';
      });
    });
  }

  // ---------- Wiring ----------
  function handleAnyChange() {
    renderPrices();
    clearError();
  }

  choiceRadios.forEach(function (r) { r.addEventListener('change', handleAnyChange); });

  if (atcBtn) atcBtn.addEventListener('click', handleAtcClick);

  // bfcache-Restore (Checkout → Browser-Zurück): Button-Zustand hart zurücksetzen.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    setBusy(false);
    clearError();
  });

  // Initial-Render
  renderPrices();
})();
